export function trackAvailableMediaHeight(mediaArea: HTMLDivElement | null) {
  const modalDialog = mediaArea?.closest<HTMLElement>('.modal-dialog');
  const modalContent = mediaArea?.closest<HTMLElement>('.modal-content');
  if (mediaArea == null || modalDialog == null || modalContent == null) {
    return;
  }

  const publishAvailableMediaHeight = () => {
    const dialogHeightLimit = Number.parseFloat(getComputedStyle(modalDialog).maxHeight);
    if (!Number.isFinite(dialogHeightLimit) || modalContent.offsetHeight === 0) {
      return;
    }

    const chromeHeight = modalContent.offsetHeight - mediaArea.offsetHeight;
    const availableMediaHeight = Math.floor(dialogHeightLimit - chromeHeight);
    if (availableMediaHeight <= 0) {
      return;
    }

    modalContent.style.setProperty('--media-viewer-max-media-height', `${availableMediaHeight}px`);
  };

  publishAvailableMediaHeight();

  const chromeResizeObserver = new ResizeObserver(publishAvailableMediaHeight);
  chromeResizeObserver.observe(modalContent);
  window.addEventListener('resize', publishAvailableMediaHeight);

  return () => {
    chromeResizeObserver.disconnect();
    window.removeEventListener('resize', publishAvailableMediaHeight);
  };
}
